import Swiper from 'swiper/bundle';
import 'swiper/css/bundle';
import { Fancybox } from '@fancyapps/ui';
import { fadeIn, slideDown, slideUp } from '@js/common/customFunctions.js';

document.addEventListener('DOMContentLoaded', () => {
    const singleHero = document.querySelectorAll('.single-product-section');

    singleHero.forEach((section) => {
        const sliderEl = section.querySelector('.sps-img-slider');
        const thumbEl = section.querySelector('.sps-thub-slider');

        // ==========================
        // Swiper
        // ==========================
        if (sliderEl && thumbEl) {
            const thumbsSwiper = new Swiper(thumbEl, {
                slidesPerView: 'auto',
                spaceBetween: 10,
                watchSlidesProgress: true,
                slideToClickedSlide: true,
            });

            new Swiper(sliderEl, {
                slidesPerView: 1,
                loop: true,
                effect: 'fade',
                fadeEffect: {
                    crossFade: true,
                },
                autoplay: {
                    delay: 5000,
                    disableOnInteraction: false,
                },
                navigation: {
                    nextEl: sliderEl.parentNode.querySelector(
                        '.sps-button-next',
                    ),
                    prevEl: sliderEl.parentNode.querySelector(
                        '.sps-button-prev',
                    ),
                },
                thumbs: {
                    swiper: thumbsSwiper,
                },
            });
        }

        // ==========================
        // Dropdown
        // ==========================
        const dropdownWrap = section.querySelector('.dropdown-list-wrap');

        if (!dropdownWrap) {
            return;
        }

        const selected = dropdownWrap.querySelector('.dropdown-selected');
        const list = dropdownWrap.querySelector('.dropdown-list');
        const items = dropdownWrap.querySelectorAll('.dropdown-item');
        const details = section.querySelectorAll('.sps-details-item');

        if (!selected || !list) {
            return;
        }

        // Toggle dropdown
        selected.addEventListener('click', (e) => {
            e.stopPropagation();

            if (dropdownWrap.classList.contains('active')) {
                dropdownWrap.classList.remove('active');
                slideUp(list);
            } else {
                dropdownWrap.classList.add('active');
                slideDown(list);
            }
        });

        // Select item
        items.forEach((item) => {
            item.addEventListener('click', () => {
                const size = item.dataset.size;

                // Update selected text
                selected.textContent = item.textContent;

                // Active item
                items.forEach((el) => el.classList.remove('active'));
                item.classList.add('active');

                // Close dropdown
                dropdownWrap.classList.remove('active');
                slideUp(list);

                // Update details
                details.forEach((detail) => {
                    if (detail.dataset.id === size) {
                        detail.style.display = 'block';
                        fadeIn(detail);
                    } else {
                        detail.style.display = 'none';
                    }
                });
            });
        });

        // Close dropdown when clicking outside
        document.addEventListener('click', (e) => {
            if (
                dropdownWrap.classList.contains('active') &&
				!dropdownWrap.contains(e.target)
            ) {
                dropdownWrap.classList.remove('active');
                slideUp(list);
            }
        });
    });

    // ==========================
    // Catalog Form — Fancybox
    // ==========================
    const catalogBtns = document.querySelectorAll('.catalog-form-btn');
    let catalogFileUrl = '';

    /**
	 * Trigger a browser file download for the given URL.
	 */
    const triggerDownload = (url) => {
        if (!url) {
            return;
        }
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', '');
        link.style.display = 'none';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };

    /**
	 * Handle Forminator submit success:
	 * close Fancybox, then trigger catalog file download.
	 */
    const handleForminatorSuccess = () => {
        Fancybox.close();
        if (catalogFileUrl) {
            // Brief delay so the user sees the success message before download starts
            setTimeout(() => {
                triggerDownload(catalogFileUrl);
            }, 800);
        }
    };

    // Open the catalog form inline via Fancybox when CTA button is clicked
    catalogBtns.forEach((btn) => {
        btn.addEventListener('click', () => {
            catalogFileUrl = btn.dataset.catalogUrl || '';

            Fancybox.show(
                [
                    {
                        src: '#catalog-form-inline',
                        type: 'inline',
                    },
                ],
                {
                    mainClass: 'catalog-fancybox',
                    animated: true,
                    dragToClose: false,
                    on: {
                        // Attach Forminator success listener each time the popup opens
                        reveal: () => {
                            if (typeof window.jQuery !== 'undefined') {
                                window
                                    .jQuery(document)
                                    .off(
                                        'forminator:form:submit:success.catalog forminatorFrontSubmitSuccess.catalog',
                                    )
                                    .on(
                                        'forminator:form:submit:success.catalog forminatorFrontSubmitSuccess.catalog',
                                        handleForminatorSuccess,
                                    );
                            }
                            // Native CustomEvent fallback (fires once per open)
                            document.addEventListener(
                                'forminator:form:submit:success',
                                handleForminatorSuccess,
                                { once: true },
                            );
                        },
                    },
                },
            );
        });
    });
});
